import { BarChart3 } from "lucide-react";
import { monthlyRevenue, money } from "../lib/payments";

const label = (ym) => new Date(`${ym}-15T12:00:00`).toLocaleDateString(undefined, { month: "long", year: "numeric" });

export const RevenueView = ({ payments }) => {
  const rows = monthlyRevenue(payments);
  return (
    <div data-testid="revenue-view" className="bg-[#13161C] border border-[#262C38] rounded-md">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-[#262C38]">
        <BarChart3 className="h-4 w-4 text-[#F95722]" />
        <span className="font-heading font-bold uppercase tracking-wide text-white">Monthly revenue</span>
        <span className="font-mono text-[10px] text-slate-500 ml-auto">by date money moved</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="font-mono text-[10px] uppercase tracking-widest text-slate-500">
              <th className="px-2 sm:px-3 py-2 text-left">Month</th>
              <th className="px-2 sm:px-3 py-2 text-right">Received</th>
              <th className="px-2 sm:px-3 py-2 text-right">To setters</th>
              <th className="px-2 sm:px-3 py-2 text-right">Profit</th>
              <th className="px-2 sm:px-3 py-2 text-right">Late fees</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.month} data-testid={`revenue-row-${r.month}`} className={`border-t border-[#262C38] ${i === 0 ? "bg-[#0B0C0E]" : ""}`}>
                <td className="px-2 sm:px-3 py-2.5 text-white whitespace-nowrap">{label(r.month)}</td>
                <td data-testid={`revenue-received-${r.month}`} className="px-2 sm:px-3 py-2.5 text-right font-mono text-emerald-300">{money(r.received)}</td>
                <td data-testid={`revenue-setters-${r.month}`} className="px-2 sm:px-3 py-2.5 text-right font-mono text-slate-300">{money(r.setters)}</td>
                <td data-testid={`revenue-profit-${r.month}`} className={`px-2 sm:px-3 py-2.5 text-right font-mono font-bold ${r.received - r.setters < 0 ? "text-red-300" : "text-white"}`}>{money(r.received - r.setters)}</td>
                <td data-testid={`revenue-fees-${r.month}`} className="px-2 sm:px-3 py-2.5 text-right font-mono text-amber-300">{r.fees ? money(r.fees) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="px-4 py-2 text-[11px] font-mono text-slate-500 border-t border-[#262C38]">
        Received = carrier halves ticked as received that month. Profit = received − setter payouts sent that month. Late fees = fees billed on payments received late (shown separately, not in profit).
      </p>
    </div>
  );
};
